// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiftref-pagination i {
    border: solid var(--accent-strong-default);
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    position: relative;
    top: -2px;
}
.swiftref-pagination .disabled i {
    border-color: var(--text-default);
}

.swiftref-pagination .right {
    transform: rotate(-45deg);
    left: -1px;
}

.swiftref-pagination .left {
    transform: rotate(135deg);
    right: -1px;
}

.swiftref-pagination .up {
    transform: rotate(-135deg);
}

.swiftref-pagination .down {
    transform: rotate(45deg);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/pagination/style/arrows.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".swiftref-pagination i {\n    border: solid var(--accent-strong-default);\n    border-width: 0 2px 2px 0;\n    display: inline-block;\n    padding: 3px;\n    position: relative;\n    top: -2px;\n}\n.swiftref-pagination .disabled i {\n    border-color: var(--text-default);\n}\n\n.swiftref-pagination .right {\n    transform: rotate(-45deg);\n    left: -1px;\n}\n\n.swiftref-pagination .left {\n    transform: rotate(135deg);\n    right: -1px;\n}\n\n.swiftref-pagination .up {\n    transform: rotate(-135deg);\n}\n\n.swiftref-pagination .down {\n    transform: rotate(45deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
